import React, { useState } from 'react';
import { useTheme } from 'styled-components';
import {
  Friend as SharedFriend,
  OutlinedButton,
  useLocalStorageCooldown
} from '@make-software/tg-mini-app-ui';

import GoldIcon from '@/shared/assets/icons/gold.svg';
import { Friend as FriendEntity, AssetBalance } from '@/entities';

interface FriendsProps {
  friend: FriendEntity;
  index: number;
  onPushFriend: (id: string) => void;
}

export const Friend = ({ friend, index, onPushFriend }: FriendsProps) => {
  const [disabled, setDisabled] = useState<boolean>(false);
  const { isInCooldown } = useLocalStorageCooldown({
    key: friend.id.toString(),
    cooldownHours: 24,
    campaignEndsAt: '2026-07-31T12:00:00Z'
  });

  const handlePushFriend = (id: string) => {
    onPushFriend(id);
    setDisabled(true);
  };

  const { username, id } = friend;
  const points = friend.balances.find((b: AssetBalance) => b.unit === 'points')?.balance || 0;
  const theme = useTheme();
  return (
    <SharedFriend
      background={'#30313B'}
      border="1px solid #41424E"
      borderRadius="8px"
      indexFont={{
        fontFamily: theme.typography.fontFamily.sans,
        color: theme.colors.contentPrimary,
        fontSize: '12px',
        fontWeight: 500
      }}
      usernameFont={{
        fontFamily: theme.typography.fontFamily.sans,
        color: theme.colors.contentPrimary,
        fontSize: '12px',
        fontWeight: 500
      }}
      pointsFont={{
        fontFamily: theme.typography.fontFamily.display,
        color: theme.colors.contentPrimary,
        fontSize: '12px',
        fontWeight: 500
      }}
      index={index}
      friend={{ id, username, points }}
      earnIconSrc={GoldIcon}
      earnIconColor="#F1BF0B"
      actionButton={
        <OutlinedButton
          disabled={disabled || isInCooldown}
          onClick={() => handlePushFriend(id)}
          width={56}
          height={24}
          title="Push"
          borderRadius="4px"
          padding="2px 8px"
          fontFamily={theme.typography.fontFamily.sans}
        />
      }
    />
  );
};
